"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const Modal_1 = require("@components/atoms/Modal");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
var ConfirmationModal = function ConfirmationModal(_ref) {
    var children = _ref.children, title = _ref.title, message = _ref.message, dismiss = _ref.dismiss, action = _ref.action, actionLabel = _ref.actionLabel, actionColor = _ref.actionColor;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalContent, null, /*#__PURE__*/ react_1.default.createElement(StyledModalCopy, null, /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalHeadline, null, title), /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalSubhead, null, message), children), /*#__PURE__*/ react_1.default.createElement(ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        type: "outline",
        onClick: dismiss
    }, "Cancel"), /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        type: "solid",
        color: actionColor ? actionColor : _theme_1.palette.vermillion,
        onClick: action,
        shadow: true
    }, actionLabel))));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "ConfirmationModal__Wrapper",
    componentId: "sc-1fwezss-0"
})(["background-color:", ";width:fit-content;max-width:600px;box-shadow:0px 0.5px 0px rgba(0,0,0,0.08),0px 16px 24px rgba(0,0,0,0.08);"], _theme_1.palette.snow);
var StyledModalCopy = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalCopy, props);
}).withConfig({
    displayName: "ConfirmationModal__StyledModalCopy",
    componentId: "sc-1fwezss-1"
})(["width:100% !important;padding:24px 32px;margin:0 !important;", "{padding:32px 40px;}", "{padding-left:48px;padding-right:48px;}", "{padding-top:40px;padding-bottom:40px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var ButtonWrapper = styled_components_1.default.div.withConfig({
    displayName: "ConfirmationModal__ButtonWrapper",
    componentId: "sc-1fwezss-2"
})(["display:flex;flex-direction:column;padding:24px 32px;border-top:1px solid ", ";& > div{order:2;display:flex;width:100%;&:last-of-type{order:1;margin-right:0;margin-bottom:16px;}}", "{flex-direction:row;justify-content:flex-end;align-items:center;padding:32px 40px;& > div{order:1;width:fit-content;margin-right:24px;margin-bottom:0 !important;&:last-of-type{order:2;}}}", "{padding-left:48px;padding-right:48px;}"], _utils_1.rgba(_theme_1.palette.ink, 0.16), _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop')); // Typing
exports.default = ConfirmationModal;
